import { useContext } from 'react'
import type { SoundContextValue } from './SoundProvider'
import { SoundContext } from './SoundProvider'

/**
 * Access to the sound kit.
 *
 * Most of the site never calls this — hover and click are delegated at the
 * document level. It exists for cues that no DOM event implies, such as a
 * filter committing or a route changing.
 *
 * Throws outside the provider rather than returning a silent stub, because a
 * missing provider is a wiring bug and should fail where it happens.
 */
export const useSound = (): SoundContextValue => {
  const context = useContext(SoundContext)
  if (!context) {
    throw new Error('useSound must be used inside <SoundProvider>')
  }
  return context
}
